// extracted by mini-css-extract-plugin
export default {"root":"IconUser_root__y74tu"};